import { ListTag } from "@seagames/ui";

/**
 * A card holder's role beside their name (user, 2026-11-03: every person
 * shown carries their role and function): the category's code as a tag (its
 * name in the tooltip), the category name, then the function when the card
 * has one — "[Aa] Athlete · Swimmer".
 */
export function PersonRole({
	category,
	fn,
	className = "",
}: {
	category: { code: string; name: string } | null;
	fn: { name: string } | null | undefined;
	className?: string;
}) {
	if (!category && !fn) return null;
	return (
		<span className={`inline-flex max-w-full min-w-0 items-center gap-[0.3125rem] ${className}`}>
			{category && <ListTag title={category.name}>{category.code}</ListTag>}
			<span className="min-w-0 truncate">
				{category?.name}
				{category && fn ? " · " : ""}
				{fn?.name}
			</span>
		</span>
	);
}
